export default "__VITE_ASSET__Ckcac0g2__"